export const DEFAULT_MAX_SIZE = 2097152;
